
































































import { Component, Vue } from "vue-property-decorator";
import IconClose from "@/common/components/icons/IconClose.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import ModalNotifyThanksPointDenial from "@/general/components/organisms/ModalNotifyThanksPointDenial.vue";

import modalState from "@/common/store/modules/modalState";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import CONST_DATA from "@/general/mixins/const/constData";

import {
  getPointNotification,
  markNotificationAsRead
} from "@/general/store/api";
import LocalStorage from "@/general/utils/storage";

@Component({
  components: {
    IconClose,
    IconBase,
    PointNotation,
    ModalNotifyThanksPointDenial
  }
})
export default class TheH01Notification extends Vue {
  notification: Array<any> = [];

  notifyDenialUser: any = {};
  notifyDenialTransaction: any = {};
  notifyDenialReason = "";

  get modalName() {
    return modalState.modalName;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  async getNotification() {
    const response = await getPointNotification(
    "false",
    "-created_at",
    undefined,
    100,
    "true",
    undefined,
    undefined
    );


    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );

    const approvedTargetStr = "へのサンクスメッセージが承認されました";
    const approvedTargetRegex = new RegExp(approvedTargetStr + "(?!.*" + approvedTargetStr + ")", "g");
    const approvedReplaceStr = "への" + this.thanksPointName + "メッセージが承認されました";

    const rejectedTargetStr = "へのサンクスメッセージが否認されました";
    const rejectedTargetRegex = new RegExp(rejectedTargetStr + "(?!.*" + rejectedTargetStr + ")", "g");
    const rejectedReplaceStr = "への" + this.thanksPointName + "メッセージが否認されました";

    // 'notification_type', models.PositiveSmallIntegerField(choices=[(10, 'Grant Points cancelled'), (20, 'Thanks points approved'), (30, 'Thanks points disapproved'), (40, 'Received Grant Points')
    this.notification =
      response?.results?.map((result: any) => {
        const { pk, from_user, transaction, notification_type } = result;
        const sign =
          notification_type === 30 || notification_type === 40 ? true : false;
        const user = from_user;

        let targetNum = 0;
        if (notification_type === 10) {
          if(result.grant_criteria_id === 0 || result.register_process === "SCR-UPL-0060") {
            targetNum = result.content.lastIndexOf("への付与（配布）が取り消されました");
          } else {
            targetNum = result.content.lastIndexOf("の付与（配布）が取り消されました");
          }
        } else if (notification_type === 20) {
          result.content = result.content.replace(approvedTargetRegex, approvedReplaceStr);
          targetNum = result.content.lastIndexOf(approvedReplaceStr);
        } else if (notification_type === 30) {
          result.content = result.content.replace(rejectedTargetStr, rejectedReplaceStr);
          targetNum = result.content.lastIndexOf(rejectedReplaceStr);
        }

        return {
          id: pk,
          type: notification_type,
          date: this.$dayjs
            .utc(result.created_at)
            .locale("ja")
            .format("YYYY/MM/DD"),
          state: result.notification_type_display,
          subject: result.content,
          subject1: result.content.substring(0, targetNum),
          subject2: result.content.substring(targetNum),
          point: {
            point: result.points,
            sign
          },
          checked: false,
          user,
          transaction
        };
      }) || [];
  }

  async closeNotification(id: number) {
    for (let i = 0; i < this.notification.length; i++) {
      if (this.notification[i].id === id) {
        this.notification.splice(i, 1);
        await markNotificationAsRead(id);
      }
    }
  }

  showNotificationDetails(type: number, index: number) {
    if (type === 30) {
      this.notifyDenialUser = this.notification[index].user;
      this.notifyDenialTransaction = this.notification[index].transaction;
      this.notifyDenialReason = this.notification[index].subject;

      modalState.changeModal("notifyThanksPointDenial");
    }
  }

  created() {
    this.getNotification();
  }

}
